export default "__VITE_ASSET__90Nh2C3b__"